import { configureStore } from '@reduxjs/toolkit';

import { setApiStore } from '../services/api';
import authReducer from './slices/authSlice';
import companyReducer from './slices/companySlice';
import pdfReducer from './slices/pdfSlice';
import systemReducer from './slices/systemSlice';
import uiReducer from './slices/uiSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    company: companyReducer,
    pdf: pdfReducer,
    system: systemReducer,
    ui: uiReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

// Set the store reference for the API interceptor
setApiStore(store);
